const doc = [({"ja":({"adminConstantChannelManagerType":({"noCollaboration":"連携しない", "tlLincoln":"TLリンカーン", "temairazu":"手間いらず", "neppan":"ねっぱん", "raku2":"らく通"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;